import Faq from "./Faq";

export const faq = {
    init: () => {
        const faqQuestions = document.querySelectorAll(".sd-faq-item-title");
        if (faqQuestions) { 
            new Faq(faqQuestions)
        }
    },
}

export default faq;